export function getCookie(name) {
  const match = document.cookie.match(new RegExp(`${name}=([^;]+)`));
  if (match && match[1]) return match[1];
  return null;
}

export function getVWOExperimentVariant(experimentId) {
  return new Promise((resolve, reject) => {
    let timeoutId = 0;
    window.VWO = window.VWO || [];
    // Event to get when VWO is ready
    window.VWO.push(['onEventReceive', 'uC', function () {
      // If timeout is not set yet
      if (!timeoutId) {
        // Set it
        timeoutId = setTimeout(() => {
          // and throw that experiment is not found
          reject(new Error(`There is no VWO experiment with ${experimentId} ID`));
        }, 500);
      }
    }]);
    window.VWO.push(['onEventReceive', 'vA', function (data) {
      // set timeout to manage if 100 ms passed after first event, so there is no such experiment
      if (!timeoutId) {
        timeoutId = setTimeout(() => {
          reject(new Error(`There is no VWO experiment with ${experimentId} ID`));
        }, 100);
      }
      if (data[1] === String(experimentId)) {
        clearTimeout(timeoutId);
        resolve(Number(data[2]));
      }
    }]);
  });
}
